import { render, staticRenderFns } from "./WarrantsKnowItAll.vue?vue&type=template&id=641a04f9&scoped=true&"
import script from "./WarrantsKnowItAll.js?vue&type=script&lang=js&"
export * from "./WarrantsKnowItAll.js?vue&type=script&lang=js&"
import style0 from "./WarrantsKnowItAll.vue?vue&type=style&index=0&id=641a04f9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641a04f9",
  null
  
)

export default component.exports